import { createSvgIcon } from '@mui/material';

const FilterIcon = (props) => {
  const { filled = false } = props;
  const IconCmp = createSvgIcon(
    <>
      <path
        d="M2.35192 3.44498C1.78466 2.81099 1.50104 2.49399 1.49034 2.22458C1.48104 1.99055 1.58162 1.76561 1.76222 1.61649C1.97013 1.44482 2.39549 1.44482 3.24621 1.44482H14.3784C15.2291 1.44482 15.6545 1.44482 15.8624 1.61649C16.043 1.76561 16.1436 1.99055 16.1343 2.22458C16.1236 2.49399 15.84 2.81099 15.2727 3.44498L10.993 8.22815C10.8799 8.35453 10.8234 8.41772 10.7831 8.48963C10.7473 8.55341 10.7211 8.62208 10.7052 8.69345C10.6873 8.77393 10.6873 8.85872 10.6873 9.0283V13.0386C10.6873 13.1853 10.6873 13.2586 10.6637 13.322C10.6428 13.378 10.6088 13.4283 10.5645 13.4685C10.5144 13.514 10.4463 13.5412 10.3101 13.5957L7.76014 14.6157C7.48449 14.726 7.34666 14.7811 7.23601 14.7581C7.13926 14.738 7.05435 14.6805 6.99975 14.5981C6.93731 14.5039 6.93731 14.3555 6.93731 14.0586V9.0283C6.93731 8.85872 6.93731 8.77393 6.9194 8.69345C6.90352 8.62208 6.87728 8.55341 6.84153 8.48963C6.80121 8.41772 6.74467 8.35453 6.6316 8.22815L2.35192 3.44498Z"
        stroke="currentColor"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </>,
    'FilterIcon',
  );

  const FilledIconCmp = createSvgIcon(
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.28919 0.528322C4.30667 0.528323 4.32421 0.528324 4.34182 0.528324L21.7112 0.528322C22.3278 0.528292 22.8682 0.528265 23.2922 0.56639C23.6991 0.60297 24.2574 0.688849 24.7098 1.06239C25.2717 1.52634 25.5846 2.22614 25.5557 2.95424C25.5324 3.54047 25.2241 4.01381 24.9801 4.34142C24.7257 4.68285 24.3654 5.08557 23.9543 5.54502L17.2619 13.0248C17.1676 13.1301 17.1209 13.1826 17.0885 13.2221L17.0861 13.2251L17.0859 13.2288C17.0838 13.2799 17.0835 13.3502 17.0835 13.4915V19.7298C17.0835 19.7425 17.0837 19.7574 17.0839 19.7742C17.0856 19.9346 17.0891 20.2675 16.9731 20.5784C16.8756 20.8399 16.7169 21.0742 16.5104 21.2619C16.2648 21.485 15.9544 21.6054 15.8048 21.6634C15.7892 21.6694 15.7753 21.6748 15.7634 21.6796L11.7642 23.2793C11.5788 23.3535 11.3739 23.4355 11.1932 23.4894C10.9987 23.5475 10.6793 23.6234 10.3108 23.5468C9.85929 23.453 9.46305 23.1847 9.20824 22.8003C9.00031 22.4866 8.95212 22.1619 8.93378 21.9598C8.91673 21.7719 8.91679 21.5511 8.91685 21.3515L8.91686 13.4915C8.91686 13.3502 8.91662 13.2799 8.91444 13.2288L8.91427 13.2251L8.91187 13.2221C8.87945 13.1826 8.83278 13.1301 8.73853 13.0248L2.08125 5.58427C2.06951 5.57114 2.05781 5.55807 2.04615 5.54504C1.63501 5.08558 1.27464 4.68285 1.02031 4.34142C0.77627 4.01381 0.467993 3.54047 0.444713 2.95424C0.415799 2.22614 0.728689 1.52634 1.29058 1.06239C1.74298 0.688849 2.30129 0.60297 2.70816 0.56639C3.13221 0.528265 3.67263 0.528292 4.28919 0.528322Z"
        fill="currentColor"
      />
    </>,
    'FilterIcon',
  );

  return filled ? (
    <FilledIconCmp
      width="20"
      height="20"
      viewBox="0 0 26 24"
      style={{ fill: 'none' }}
      {...props}
    />
  ) : (
    <IconCmp
      width="20"
      height="20"
      viewBox="0 0 17 16"
      style={{ fill: 'none' }}
      {...props}
    />
  );
};
export default FilterIcon;
